import classnames from 'classnames';
import React from 'react';
import Img from 'react-image';
import { Translate, withLocalize } from "react-localize-redux";
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { chartActions } from '../../../store/charts/chartsStore';
import { _getProfiVersionChecked } from '../../../store/charts/topPanel/actions';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import ChartTooltipNotesRow from './chartTooltipNotesRow';

import semafor1 from '../../../img/charts/semafor_1.png';
import semafor2 from '../../../img/charts/semafor_2.png';
import semafor3 from '../../../img/charts/semafor_3.png';

import '../relationChart.scss';
import '../relationChartFonts.scss';

class ChartEntityTooltip extends React.Component {
    render() {
        const { nodeTooltip } = this.props.charts;

        if (isNullOrUndefined(nodeTooltip) || !nodeTooltip.show || isNullOrUndefined(nodeTooltip.context))
            return null;

        const { data, position } = nodeTooltip.context;

        const hasSemaphore = data.Type !== "Person" && data.SemaphoreCode != null && data.SemaphoreCode !== '';
        const hasWarnings = data.WarningShortcuts != null && data.WarningShortcuts !== undefined && data.WarningShortcuts.length > 0;
        const hasNotes = data.CustomNotes != null && data.CustomNotes !== undefined && data.CustomNotes.length > 0;

        return (
            <div id="entityHoverPopup" className="entity-hover-popup"
                style={{ display: 'block', top: `${position.y}px`, left: `${position.x}px` }}>
                <table>
                    <tbody>
                        {data.EntityType === 'AD' && this.renderAdEntityTooltip(data)}
                        {data.EntityType !== 'AD' && <>
                            {data.EntityType === 'FO' && this.renderFoEntityTooltip(data)}
                            {data.EntityType !== 'FO' && this.renderNotFoEntityTooltip(data)}
                            <tr><th><Translate id='Charts.PersonAddress' /></th><td>{data.FullAddress} {data.AddressSrc !== null && <> ({data.AddressSrc})</>}</td></tr>
                        </>}
                        {(hasSemaphore || hasWarnings || hasNotes) && <tr><th>&nbsp;</th><td>&nbsp;</td></tr>}
                        {hasSemaphore && this.renderSemaphore(data)}
                        {hasWarnings && this.renderWarnings(data)}
                        {hasNotes && <ChartTooltipNotesRow notes={data.CustomNotes} colspan={2} />}
                    </tbody>
                </table>
            </div>
        );
    }

    renderAdEntityTooltip = (tooltipData) => {
        if (tooltipData.Type === 'Custom') {
            return (<tr><th><Translate id='Charts.PersonAddress' /></th><td>{tooltipData.Name}</td></tr>);
        }

        return (
            <>
                <tr><th><Translate id='Charts.Street' /></th><td>{tooltipData.Street}</td></tr>
                <tr><th><Translate id='Charts.City' /></th><td>{tooltipData.City}</td></tr>
                <tr><th><Translate id='Charts.ZIP' /></th><td>{tooltipData.Zip}</td></tr>
                <tr><th><Translate id='Charts.Country' /></th><td>{tooltipData.Country}</td></tr>
                {((tooltipData.Ruian !== null && tooltipData.Ruian !== '' && tooltipData.Ruian !== 0) || (tooltipData.RegAdr !== null && tooltipData.RegAdr !== '' && tooltipData.RegAdr !== 0) || (tooltipData.GooglePlaceId !== null && tooltipData.GooglePlaceId !== '')) &&
                    <>
                        <tr><th>&nbsp;</th><td>&nbsp;</td></tr>
                        {(tooltipData.Ruian !== null && tooltipData.Ruian !== '' && tooltipData.Ruian !== 0) && <tr><th><Translate id='Charts.RUIAN' /></th><td>{tooltipData.Ruian}</td></tr>}
                        {(tooltipData.RegAdr !== null && tooltipData.RegAdr !== '' && tooltipData.RegAdr !== 0) && <tr><th><Translate id='Charts.SkAddressRegister' /></th><td>{tooltipData.RegAdr}</td></tr>}
                        {(tooltipData.GooglePlaceId !== null && tooltipData.GooglePlaceId !== '') && <tr><th><Translate id='Charts.GooglePlaceId' /></th><td>{tooltipData.GooglePlaceId}</td></tr>}
                    </>
                }
                {(tooltipData.CountryCode === '19') &&
                    <>
                        <tr><th>&nbsp;</th><td>&nbsp;</td></tr>
                        {(tooltipData.FlatCount == null || tooltipData.FlatCount === undefined || tooltipData.FlatCount === 0) && <tr><th><Translate id='Charts.NoFlatCount' options={{ renderInnerHtml: true }} /></th><td>&nbsp;</td></tr>}
                        {(!(tooltipData.FlatCount == null || tooltipData.FlatCount === undefined || tooltipData.FlatCount === 0)) && <tr><th><Translate id='Charts.FlatCount' options={{ renderInnerHtml: true }} /></th><td>{tooltipData.FlatCount}</td></tr>}
                    </>
                }
            </>
        );
    }

    renderFoEntityTooltip = (tooltipData) => {
        return (
            <>
                <tr><th><Translate id='Charts.PersonFullName' /></th><td>{tooltipData.Name}</td></tr>
                <tr><th><Translate id='Charts.PersonDateOfBirth' /></th><td>{tooltipData.DateOfBirthOrCreationDateFormated}</td></tr>
            </>
        );
    }

    renderNotFoEntityTooltip = (tooltipData) => {
        return (
            <>
                <tr><th><Translate id='Charts.CompanyName' /></th><td>{tooltipData.Name}</td></tr>
                <tr><th><Translate id='Charts.CompanyIC' /></th><td>{tooltipData.IC}</td></tr>
            </>
        );
    }

    renderSemaphore = (tooltipData) => {
        return (
            <>
                <tr>
                    {tooltipData.Type === 'Custom' && <th><Translate id='Charts.AddEntitySubjectRating' /></th>}
                    {tooltipData.Type !== 'Custom' && <th><Translate id='Charts.SemaphoreCribis' /></th>}
                    <td>
                        {tooltipData.SemaphoreCode === '1' && <Img style={{ width: '26px', padding: '0 4px 0 4px' }} src={semafor1} />}
                        {tooltipData.SemaphoreCode === '2' && <Img style={{ width: '26px', padding: '0 4px 0 4px' }} src={semafor2} />}
                        {tooltipData.SemaphoreCode === '3' && <Img style={{ width: '26px', padding: '0 4px 0 4px' }} src={semafor3} />}
                        {tooltipData.Type !== 'Custom' && <Translate id={`Charts.SemaphoreDesc${tooltipData.SemaphoreCode}`} />}
                    </td>
                </tr>
            </>
        );
    }

    _isItalic = function (useProfi, target) {
        if (useProfi) {
            return !this._isActualWarning(target)
        }

        if (target.StatusID === "0x" || target.StatusID === "0y") {
            return false;
        }
        return false;
    }

    _isActualWarning = function (warning) {
        return warning.StatusID === "01" || warning.StatusID === "03" || warning.StatusID === "05" || warning.StatusID === "0x";
    }

    renderWarnings = (tooltipData) => {
        const profi = _getProfiVersionChecked()
        const first = tooltipData.WarningShortcuts.filter(function (e) { return e.IsFiltered && e.StatusID !== '0x' && e.StatusID !== '0y'; });
        const additional = tooltipData.WarningShortcuts.filter(function (e) { return e.IsFiltered && (e.StatusID === '0x' || e.StatusID === '0y'); });

        return (
            <>
                {first.length !== null && first.length !== undefined && first.length !== 0 && <tr>
                    <th><Translate id='Charts.CompanyWarnings' /></th>
                    <td>
                        <table className={classnames({ 'warn-profi': profi })}>
                            <tbody>
                                {first.map((f, i) => <tr key={i}>
                                    <td><span className={`warn-item warn-status-${f.StatusID}`}>{f.WarningsCode}</span></td>
                                    <td style={{ fontStyle: this._isItalic(profi, f) ? 'italic' : 'normal', paddingTop: '3px' }}>{f.Description}</td>
                                </tr>)}
                            </tbody>
                        </table>
                    </td>
                </tr>}
                {additional.length !== null && additional.length !== undefined && additional.length !== 0 && <tr>
                    <th><Translate id='Charts.AdditionalInformations' /></th>
                    <td>
                        <table className={classnames({ 'warn-profi': profi })}>
                            <tbody>
                                {additional.map((f, idx) => <tr key={idx}>
                                    <td><span className={`warn-item warn-status-${f.StatusID}`}>{f.WarningsCode}</span></td>
                                    <td style={{ fontStyle: this._isItalic(profi, f) ? 'italic' : 'normal', paddingTop: '3px' }}>{f.Description}</td>
                                </tr>)}
                            </tbody>
                        </table>
                    </td>
                </tr>}
            </>
        );
    }
}

export default withRouter(withLocalize(connect(
    state => ({ charts: state.charts }),
    dispatch => bindActionCreators({ ...chartActions }, dispatch)
)(ChartEntityTooltip)));